var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "m9.01 10.125.5-3.258H6.383V4.753a1.63 1.63 0 0 1 1.837-1.76h1.421V.22A17 17 0 0 0 7.118 0C4.544 0 2.861 1.56 2.861 4.385v2.482H0v3.258h2.861V18h3.522v-7.875z"
})));
export { SvgFacebook as ReactComponent };
export default __webpack_public_path__ + "c51155d222e206792dfe25530e3370b6.svg";